import { RecurrenceStatus, TaskCompletionStateFragment } from "gql/graphql";

/**
 * Задача закрыта: однократная — выполнена, серия — закрыта (кончилась по расписанию
 * или закрыта вручную), новых срабатываний больше не будет.
 * То же правило, по которому бэкенд понимает фильтр `isDone`.
 */
export function isTaskDone(task: TaskCompletionStateFragment): boolean {
  const { completion } = task;

  if (completion.__typename === "RecurringCompletionDto") {
    return completion.status !== RecurrenceStatus.Active;
  }

  return completion.isDone;
}
